
/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import { motion } from 'framer-motion';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados } from '../../../services/selectors';
import { formatCaracteristicas, formatSelects, formatSelectsTransacao, isColorLight, removerAcentos } from '../../../utils/FunctionsGlobals';
import { useAuth } from '../../context/Info';
import DrawerComponent from '../../drawer/DrawerComponent';
import { customSelectPropertiesStyles } from './WelcomePieces.mocks';
import styles from './WelcomePieces2.module.css';

interface IWelcomePieces2 {
  personaSrc: any;
  allCities: Array<{ label: string; value: string; id_estado: any }>;
  allTypes: any;
  allTransacao: Array<{ label: string; value: string }>;
  allCompany: Array<{ label: string; value: string }>;
  site: any;
  urlBanner: string;
  companyInputActual: any;
  setCompanyInputActual: any;
  setActiveDrawer: any;
  activeDrawer: any;
  origin?: any;
  codsite?: any;
  favorito: Array<number>;
  valores?: any;
  codsite2?: any;
  isMobile1?: Boolean;
  props: any;
}

const WelcomePieces2: React.FC<IWelcomePieces2> = ({
  personaSrc,
  allCities,
  allTypes,
  allCompany,
  allTransacao,
  site,
  urlBanner,
  companyInputActual,
  setCompanyInputActual,
  setActiveDrawer,
  activeDrawer,
  origin,
  codsite,
  favorito,
  valores,
  codsite2,
  isMobile1,
  props
}) => {
  const {
      listCategory,
      setListCategory,
      listEstados,
      setListEstados,
      listCaracteristicas,
      setListCaracteristicas,
      listDatas,
      setListDatas
  } = useAuth();

  const [tipo, setTipo] = useState<any>(null);
  const [showAdvanced, setShowAdvanced] = useState<boolean>(false);
  const [transacaoActual, setTransacaoActual] = useState<any>(allTransacao[0]);
  const newFilter = () => {
      if (transacaoActual?.value) {
          if (transacaoActual.value.toLowerCase() === 'aluguel') {
              return valores?.precos_locacao[0];
          }
          if (transacaoActual.value.toLowerCase() === 'venda') {
              return valores?.precos_venda[0];
          }
      } else {
          if (allTransacao[0]?.value.toLowerCase() === 'aluguel') {
              return valores?.precos_locacao[0];
          }
          if (allTransacao[0]?.value.toLowerCase() === 'venda') {
              return valores?.precos_venda[0];
          }
      }
      if(valores?.precos_venda[0]?.max > 0){
          return valores?.precos_venda[0];
      }else{
          return valores?.precos_locacao[0];
      }
  };
  const getFiltersPricess = newFilter();
  const onlyDigits = (str: string) => str.replace(/\D/g, ''); // remove tudo que não é número
  
  const [precoMin, setPrecoMin] = useState<number>(getFiltersPricess?.min);
  const [precoMax, setPrecoMax] = useState<number>(getFiltersPricess?.max);

  function renderPath() {
    // Helper para tratar label/strings
    const treatString = (str: string, def = '-') => str ? String(str).replaceAll("-", "002D").replaceAll(" ", "%20") : def;

    // Pega valores tratados
    const transacao = transacaoActual?.value?.toLowerCase() || allTransacao[0]?.value?.toLowerCase() || 'venda';
    const cidade = treatString(citiesActual?.label);
    const bairro = treatString(urlDistrict);
    const company = treatString(companyActual?.label);
    const tipo = treatString(urlTipo);

    // Código, se houver
    const codigo = codeActual ? `/${treatString(codeActual, '').replaceAll('%20', '')}` : '';

    // Query params
    let params = '';

    if (buscaAvan || site?.id == 2177) {
      if (origin.includes("teste.sobressai.com")) {
        params =
          `&id_estado=${estadoActual?.value || ''}` +
          `&min=${precoMin || ''}` +
          `&max=${precoMax || ''}` +
          `&dormitorios=${dormitoriosActual?.value || 0}` +
          `&banheiros=${banheirosActual?.value || 0}` +
          `&suites=${suitesActual?.value || 0}` +
          `&vagas=${vagasActual?.value || 0}`;
      } else {
        params =
          `?id_estado=${estadoActual?.value || ''}` +
          `&min=${precoMin || ''}` +
          `&max=${precoMax || ''}` +
          `&data_entrega=${urlDatas || ''}` +
          `&categoria=${categoryActual?.value || ''}` +
          `&dormitorios=${dormitoriosActual?.value || 0}` +
          `&banheiros=${banheirosActual?.value || 0}` +
          `&suites=${suitesActual?.value || 0}` +
          `&vagas=${vagasActual?.value || 0}` +
          `&id_caracteristica=${urlCaract || ''}`;
      }
    } else if (codsite2 !== undefined) {
      params = `?codsite=${codsite2}`;
    }

    // Monta path final
    let newPath = `/imoveis/${transacao}/${cidade}/${bairro}/${company}/${tipo}${codigo}${params}`;

    // Corrige espaços e acentos
    newPath = newPath.replaceAll(' ', '-');
    newPath = removerAcentos(newPath).toLowerCase();

    return newPath;
  }

  const clearFilters = () => {
    setCitiesActual(null)
    setTransacaoActual(allTransacao[0])
    setPrecoMin(getFiltersPricess?.min)
    setPrecoMax(getFiltersPricess?.max)
    setDistrictActual([])
    setTypesActual([])
    setCaractActual([])
    setDataEntregaActual([])
    setCategoryActual([])
    setEstadoActual([])
    setDormitoriosAtual('')
    setBanheirosAtual('')
    setSuitesAtual('')
    setVagasAtual('')
    setCodeActual('')
    setCompanyActual(null)
  };

      const [allDistrict, setAllDistrict] = useState([]);
      const [allCitiesAux, setAllCitiesAux] = useState(site?.id == 2177 ? allCities.filter(city => city?.id_estado == 24) : allCities);
      const [citiesActual, setCitiesActual] = useState<any>(null);
      const [districtActual, setDistrictActual] = useState<Array<{label: string, value: number}>>([]);
      const [typesActual, setTypesActual] = useState<Array<{label: string, value: number}>>([]);
      const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
      const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
      const [categoryActual, setCategoryActual] = useState<any>([]);
      const [estadoActual, setEstadoActual] = useState<any>(site?.id == 2177 ? {label: 'Rio Grande do Sul', value: 23} : {value: 0});
      const [urlTipo, setUrlTipo] = useState<string>("");
      const [urlCaract, setUrlCaract] = useState<string>("");
      const [urlDatas, setUrlDatas] = useState<string>("");
      const [urlDistrict, setUrlDistrict] = useState<string>("");
      const [dormitoriosActual, setDormitoriosAtual] = useState<any>();
      const [banheirosActual, setBanheirosAtual] = useState<any>();
      const [suitesActual, setSuitesAtual] = useState<any>();
      const [vagasActual, setVagasAtual] = useState<any>();
      const [codeActual, setCodeActual] = useState('');
      const [companyActual, setCompanyActual] = useState<any>(null);
      const [buscaAvan, setBuscaAvan] = useState<boolean>(false);
      const cor_fundo = site?.cor12;
      const cor_bordas = isColorLight(site?.cor12) ? site?.cor11 : site?.cor13;

      const onChangeCity = async (txt: any) => {
          if(citiesActual == txt || !txt){
              setCitiesActual(null);
              setDistrictActual([])
              setAllDistrict([])
          }
          else{
              setCitiesActual(txt);
              const infoDistrict = await district(txt.value, origin, codsite);
              setAllDistrict(formatSelects(infoDistrict?.bairros));
              setDistrictActual([])
          }
      };
      const onChangeDistrict = (txt: any) => {
          setUrlDistrict(txt?.map((tip: any) => {return tip?.label}).join("+"))
          setDistrictActual(txt);
      };
      const onChangeCompany = (txt: any) => {
          setCompanyActual(txt);
      };
      const onChangeTypes = (txt: any) => {
          setUrlTipo(txt?.map((tip: any) => {return tip?.label}).join("+"))
          setTypesActual(txt);
      };
      const onChangeCategory = (txt: any) => {
          if(categoryActual == txt)
              setCategoryActual([]);
          else
          setCategoryActual(txt);
  
          setBuscaAvan(true);
      };
      const onChangeEstado = async (txt: any) => {
        if(estadoActual == txt)
            setEstadoActual(null);
        else{
            // selecionou um novo estado
            setEstadoActual(txt);

            // filtra apenas as cidades que batem com o id_estado
            const cidadesFiltradas = allCities.filter(
                city => city?.id_estado === txt.value
            );

            setCitiesActual(null);
            setDistrictActual([])
            setAllCitiesAux(cidadesFiltradas);
        }
    };
    const onChangeDataEntrega = (txt: any) => {
        setUrlDatas(txt?.map((tip: any) => {return tip?.value}).join(","))
        setDataEntregaActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onChangeCaracteristicas = (txt: any) => {
        setUrlCaract(txt?.map((tip: any) => {return tip?.value}).join(","))
        setCaractActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };
    const onChangeTransacao = (txt: any) => {
        setTransacaoActual(txt);
    };
    const onChangeDormitorios = (txt: any) => {
        setDormitoriosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeBanheiros = (txt: any) => {
        setBanheirosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeSuites = (txt: any) => {
        setSuitesAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeVagas = (txt: any) => {
        setVagasAtual(txt);
        setBuscaAvan(true);
    };

    const onChangeCode = (txt: React.ChangeEvent<HTMLInputElement>) => {
        setCodeActual(txt.target.value);
    };

    const GetInitialFilters = async () => {
        if(listEstados == 0 && site?.id == 2177){
            const getCondo: any = JSON.parse(localStorage.getItem('listEstados') || '[]');

            if(getCondo?.length > 0){
                setListEstados(getCondo);
            } else {
                const infoEstados = await get_estados(origin, codsite);
                const formatEstados = await formatSelects(infoEstados?.estados);
                if(formatEstados?.length > 0){
                    localStorage.setItem('listEstados', JSON.stringify(formatEstados));
                    setListEstados(formatEstados);
                }
                else
                setListEstados([]);
            }
        }

        if(listCategory == 0 && site?.categoria_home){
            const getCondo: any = JSON.parse(localStorage.getItem('listCategory1') || '[]');

            if(getCondo?.length > 0){
                setListCategory(getCondo);
            } else {
                const infoCategory = await categorias(origin, codsite);
                const formatCategorias = await formatSelects(infoCategory?.categorias);
                if(formatCategorias?.length > 0){
                    localStorage.setItem('listCategory1', JSON.stringify(formatCategorias));
                    setListCategory(formatCategorias);
                }
                else
                    setListCategory([]);
            }
        }

        if(listCaracteristicas == 0 && site?.caracteristicas_home){
            const getCondo: any = JSON.parse(localStorage.getItem('listCaracteristicas') || '[]');

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite);
                const formatCarac = await formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);
                    localStorage.setItem('listCaracteristicas', JSON.stringify(formatCarac));
                }
                else
                setListCaracteristicas([]);
            }
        }

        if(listDatas == 0 && site?.mostrar_data_entrega){
            const getCondo: any = JSON.parse(localStorage.getItem('listDatas') || '[]');

            if(getCondo?.length > 0){
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                getCondo.unshift(newItem);
                setListDatas(getCondo);
            } else {
                const infoDatas= await allDatasEntrega(origin, codsite);
                const formatDatas = await formatSelectsTransacao(infoDatas?.datas_entrega);

                if(formatDatas?.length > 0){
                    const newItem = { "label": "Imóvel Pronto", "value": 1 };

                    // Adiciona o novo item no início do array
                    formatDatas.unshift(newItem);
                    setListDatas(formatDatas);
                    localStorage.setItem('formatDatas', JSON.stringify(formatDatas));
                }
                else
                setListDatas([]);
            }
        }
    }

    useEffect(() => {
        if(showAdvanced && (site?.caracteristicas_home || site?.categoria_home || site?.mostrar_data_entrega)){
            GetInitialFilters()
        }
    }, [showAdvanced]);

    useEffect(() => {
        if(allCitiesAux?.length == 1){
            onChangeCity(allCitiesAux[0]);
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Enter") {
            redirectToLink();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    const redirectToLink = () => {
        const linkElement = document.getElementById("myLink");
        if (linkElement) {
          linkElement.click();
        }
    };
  
  const GetOnlyCityCanoas = () => {
      const GetOnlyType = allCitiesAux.filter((e: any) => {
          return String(e.label)=="Canoas";
      })
      return GetOnlyType[0];
  };

  const transacaoCount = site?.transacoes?.length || 2;

  return (
    <div className={`${styles.container}`}>
      <DrawerComponent
          site={site}
          activeDrawer={activeDrawer}
          setActiveDrawer={setActiveDrawer}
          favorito={favorito}
          menus={props?.menus}
      />
      {/* Banner Background */}
      <div 
        className={styles.banner}
        style={urlBanner ? { 
          backgroundImage: `url(${urlBanner})`,
        } : {backgroundColor: site?.cor9}}
      >
        {!urlBanner && site?.url_video && site?.id != 2177 && (
          <video
            autoPlay
            muted
            loop
            height="100%"
            width="100%"
            className={styles.video_render}
            src={site.url_video}
            playsInline
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
            }}
          >
            <track kind="captions" label="Legenda" src="legenda.vtt" />
          </video>
        )}
        {/* Overlay */}
        <div className={styles.overlay} />
        
        {/* Animated Persona - positioned behind content */}
        {personaSrc &&
        <div className={styles.persona_div}>
            <motion.img
                src={personaSrc}
                alt="Persona da imobiliária"
                className={styles.persona}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ 
                    delay: 0.2, 
                    duration: 1, 
                    ease: "easeOut" 
                }}
            />
        </div>}
        
        {/* Content */}
        <div className={styles.content}>
          {/* Welcome Text */}
          <div className={styles.textContent}>
            {site?.frase_busca ?
            site?.id == '2112' ?
              <motion.h1
                className={styles.title}
                style={{ fontSize: '64px', margin: '0px' }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6, duration: 1, ease: "easeOut" }}
                dangerouslySetInnerHTML={{
                  __html: site?.frase_busca.toUpperCase(),
                }}
              ></motion.h1>
            :
              <motion.h1
                className={styles.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6, duration: 1, ease: "easeOut" }}
                dangerouslySetInnerHTML={{
                  __html:
                    site?.id === 2177
                      ? `<span style="font-weight:100;">Descubra o Melhor do </span><span style="font-weight:bold;">Litoral Catarinense</span><span style="font-weight:100;"> e da </span><span style="font-weight:bold;">Serra Gaúcha</span>.<br>
                                <span style="font-weight:100;">Imóveis exclusivos em </span><span style="font-weight:bold;">Itapema, Gramado e Canela</span><span style="font-weight:100;"> com a </span><span style="font-weight:bold;">confiança da Imobiliária Régis da Silveira</span>.`
                      : site?.frase_busca,
                }}
              ></motion.h1>
            : null}
            {site?.frase_busca_2 ? 
              <motion.h2
                className={styles.subtitle}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8, duration: 1, ease: "easeOut" }}
              >
                {site?.frase_busca_2}
              </motion.h2> : null}
          </div>

          {/* Search Bar */}
            <motion.div
              className={styles.searchBar}
              style={{ background: cor_fundo }}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1, duration: 1, ease: "easeOut" }}
            >
            <div className={styles.column}>
              {/* Transaction Type - only show if more than 1 */}
              {transacaoCount > 1 && (
                <div className={styles.field}>
                  <Select
                      defaultValue={allTransacao[0]?.value}
                      options={allTransacao}
                      placeholder={allTransacao?.length > 0 ? allTransacao[0]?.value :"Transação"}
                      noOptionsMessage={() =>
                          'Processando'
                      }
                      menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                      styles={{
                      ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                      menuPortal: (base: any) => ({          // << z-index garantido
                        ...base,
                        zIndex: 10000,
                      })
                    }}
                      menuPlacement="auto" 
                      value={transacaoActual}
                      onChange={onChangeTransacao}
                      instanceId={1}
                      isSearchable={false}
                  />
                </div>
              )}

              {/* Property Type */}
              <div className={styles.field}>
                <Select
                    options={allTypes}
                    isMulti
                    placeholder={urlTipo ? typesActual?.length + " Selecionado (s)" : "Tipo de imóvel"}
                    closeMenuOnSelect={site?.id == "2091" ? true : false}
                    controlShouldRenderValue={false}
                    noOptionsMessage={() =>
                        'Tipo não encontrado'
                    }
                    hideSelectedOptions={false}
                    tabSelectsValue={false}
                    value={typesActual}
                    onChange={onChangeTypes}
                    closeMenuOnScroll={true}
                    isSearchable={isMobile1 ? false : true}
                    instanceId={2}
                    menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                    styles={{
                    ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                    menuPlacement="auto" 
                />
              </div>

              {/* City */}
              <div className={styles.field}>
                <Select
                  options={allCitiesAux}
                  placeholder="Cidade"
                  noOptionsMessage={() =>
                      'Cidade não encontrada'
                  }
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                  onChange={onChangeCity}
                  value={!citiesActual && site?.id == "1772" ? GetOnlyCityCanoas() : citiesActual}
                  instanceId={3}
                  menuPlacement="auto" 
                  styles={{
                    ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                  isSearchable={isMobile1 ? false : true}
                />
              </div>

              {/* District */}
              <div className={styles.field}>
                <Select
                  options={allDistrict}
                  placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                  closeMenuOnSelect={site?.id == "2091" ? true : false}
                  controlShouldRenderValue={false}
                  hideSelectedOptions={false}
                  tabSelectsValue={false}
                  noOptionsMessage={() =>
                      citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                  }
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                  menuPlacement="auto" 
                  styles={{
                    ...customSelectPropertiesStyles(cor_bordas,cor_fundo,site?.cor2,cor_bordas),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                  isMulti
                  value={districtActual}
                  onChange={onChangeDistrict}
                  isSearchable={isMobile1 ? false : true}
                  instanceId={4}
                />
              </div>

              {/* Search Button */}
              <div className={styles.fieldCTA} style={{ alignContent: "center",minHeight: "35px"}}> 
                <Link 
                  href={renderPath()}
                  type="button"
                  className={styles.cta}
                  style={{ backgroundColor: site?.cor2 || '#c4a853' }}
                >
                  Encontrar imóvel
                </Link>
              </div>
            </div>
          </motion.div>

          {/* Busca Avançada text */}
          <motion.div
            className={styles.advancedText}
            onClick={() => setShowAdvanced(true)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 1, ease: "easeOut" }}
          >
            BUSCA AVANÇADA
          </motion.div>
        </div>
      </div>

      {/* Advanced Search Popup */}
      {showAdvanced && (
        <div className={styles.popupOverlay} onClick={() => setShowAdvanced(false)}>
          <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
            <div className={styles.popupHeader}>
              <span>Buscar imóveis</span>
              <button 
                className={styles.popupClose}
                onClick={() => setShowAdvanced(false)}
              >
                ×
              </button>
            </div>

            <div className={styles.popupBody}>
              {/* Código */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Códigos</label>
                <input
                  type="text"
                  placeholder="1000, 2000, ..."
                  value={codeActual}
                  onChange={onChangeCode}
                  className={styles.formInput}
                />
              </div>

              <div className={styles.separator}>ou</div>

              {/* Transaction Type */}
              {}
              
                {transacaoCount > 1 && (
                  <div className={styles.formItem}>
                  <label className={styles.formLabel}>Negociação</label>
                  <Select
                      defaultValue={allTransacao[0]?.value}
                      options={allTransacao}
                      className={styles.select}
                      placeholder={allTransacao?.length > 0 ? allTransacao[0]?.value :"Transação"}
                      noOptionsMessage={() =>
                          'Processando'
                      }
                      menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                      styles={{
                        ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                        menuPortal: (base: any) => ({          // << z-index garantido
                          ...base,
                          zIndex: 10000,
                        }),
                      }}
                      menuPlacement="auto" 
                      value={transacaoActual}
                      onChange={onChangeTransacao}
                      instanceId={1}
                      isSearchable={false}
                  />
                </div>
              )}

              {/* Property Type */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Tipos de Imóveis</label>
                <Select
                  placeholder="Selecione"
                  options={allTypes}
                  value={tipo}
                  onChange={setTipo}
                  styles={{
                    ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
              </div>

              {/* City */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Cidade</label>
                <Select
                  options={allCitiesAux}
                  placeholder="Cidade"
                  noOptionsMessage={() =>
                      'Cidade não encontrada'
                  }
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                  onChange={onChangeCity}
                  value={!citiesActual && site?.id == "1772" ? GetOnlyCityCanoas() : citiesActual}
                  instanceId={41}
                  menuPlacement="auto" 
                  isSearchable={isMobile1 ? false : true}
                  styles={{
                    ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
              </div>

              {/* District */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Bairro</label>
                <Select
                  options={allDistrict}
                  placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                  closeMenuOnSelect={site?.id == "2091" ? true : false}
                  controlShouldRenderValue={false}
                  hideSelectedOptions={false}
                  tabSelectsValue={false}
                  noOptionsMessage={() =>
                      citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                  }
                  isMulti
                  value={districtActual}
                  onChange={onChangeDistrict}
                  isSearchable={isMobile1 ? false : true}
                  instanceId={40}
                  styles={{
                    ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
              </div>

              {/* Category */}
              {site?.categoria_home && listCategory?.length > 0 &&
                <div className={styles.formItem}>
                  <label className={styles.formLabel}>Categoria</label>
                  <Select
                    options={listCategory}
                    className={styles.select}
                    placeholder="Categoria"
                    noOptionsMessage={() =>
                        'Categoria não encontrada'
                    }
                    onChange={onChangeCategory}
                    value={categoryActual}
                    instanceId={3}
                    isSearchable={isMobile1 ? false : true}
                    styles={{
                      ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                      menuPortal: (base: any) => ({          // << z-index garantido
                        ...base,
                        zIndex: 10000,
                      }),
                    }}
                  />
              </div>}

              {/* Características */}
              {site?.caracteristicas_home && listCaracteristicas?.length > 0 &&
                <div className={styles.formItem}>
                  <label className={styles.formLabel}>Mais características</label>
                  <Select
                    options={listCaracteristicas}
                    className={styles.select}
                    isMulti
                    placeholder={urlCaract ? caractActual?.length + " Selecionada (s)" : "Características"}
                    noOptionsMessage={() =>
                        'Característica não encontrada'
                    }
                    closeMenuOnSelect={false}
                    controlShouldRenderValue={false}
                    hideSelectedOptions={false}
                    tabSelectsValue={false}
                    onChange={onChangeCaracteristicas}
                    value={caractActual}
                    closeMenuOnScroll={false}
                    instanceId={12}
                    isSearchable={isMobile1 ? false : true}
                    styles={{
                      ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                      menuPortal: (base: any) => ({          // << z-index garantido
                        ...base,
                        zIndex: 10000,
                      }),
                    }}
                  />
              </div>}

              {site?.mostrar_data_entrega && listDatas?.length > 0 &&
                <div className={styles.formItem}>
                  <label className={styles.formLabel}>Data Entrega</label>
                  <Select
                    options={listDatas}
                    className={styles.select}
                    isMulti
                    placeholder={urlDatas ? dataEntregaActual?.length + " Selecionada (s)" : "Datas de entrega"}
                    noOptionsMessage={() =>
                        'Data de entrega não encontrada'
                    }
                    closeMenuOnSelect={false}
                    controlShouldRenderValue={false}
                    hideSelectedOptions={false}
                    tabSelectsValue={false}
                    onChange={onChangeDataEntrega}
                    value={dataEntregaActual}
                    closeMenuOnScroll={false}
                    instanceId={12}
                    isSearchable={isMobile1 ? false : true}
                    styles={{
                      ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                      menuPortal: (base: any) => ({          // << z-index garantido
                        ...base,
                        zIndex: 10000,
                      }),
                    }}
                  />
                </div>
              }

              {/* Condominium */}
              {site?.exibir_empreendimento && allCompany?.length > 0 && 
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Condomínio</label>
                <Select
                  options={allCompany}
                  className={styles.select1}
                  placeholder={site?.id == "1892" ? "Residenciais e loteamentos" : "Condomínios"}
                  value={companyActual}
                  inputValue={companyInputActual}
                  noOptionsMessage={() =>
                      allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                  }
                  instanceId={9}
                  onChange={onChangeCompany}
                  onInputChange={onInputChangeCompany}
                  styles={{
                    ...customSelectPropertiesStyles('#1A1A1A','#FFFFFF',site?.cor2,'#1A1A1A'),
                    menuPortal: (base: any) => ({          // << z-index garantido
                      ...base,
                      zIndex: 10000,
                    }),
                  }}
                />
              </div>}

              {/* Price Range */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Faixa de preço</label>
                <div className={styles.priceInputs}>
                  <input
                    type="text"
                    inputMode="numeric"
                    placeholder="R$ de..."
                    value={precoMin === 0 ? '' : precoMin}      // mostra vazio quando for 0
                    onChange={(e) => {
                      const limpo = onlyDigits(e.target.value); // "12345"
                      setPrecoMin(Number(limpo));               // agora é number
                    }}
                    className={styles.formInput}
                  />
                  <input
                    min={0}
                    type="text"
                    inputMode="numeric"
                    placeholder={"R$ até..."}
                    value={precoMax === 0 ? '' : precoMax}      // mostra vazio quando for 0
                    onChange={(e) => {
                      const limpo = onlyDigits(e.target.value); // "12345"
                      setPrecoMax(Number(limpo));               // agora é number
                    }}
                    className={styles.formInput}
                  />
                </div>
              </div>

              {/* Dormitórios */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Dormitórios</label>
                <div className={styles.checkNumbers}>
                  {['1', '2', '3', '4', '5+'].map(num => (
                    <label key={num} className={styles.checkLabel}>
                      <input
                        type="checkbox"
                        checked={dormitoriosActual == num}
                        onChange={() => onChangeDormitorios(num)}
                      />
                      <span>{num}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Suites */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Suítes</label>
                <div className={styles.checkNumbers}>
                  {['1', '2', '3', '4', '5+'].map(num => (
                    <label key={num} className={styles.checkLabel}>
                      <input
                        type="checkbox"
                        checked={suitesActual == num}
                        onChange={() => onChangeSuites(num)}
                      />
                      <span>{num}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Banheiros */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Banheiros</label>
                <div className={styles.checkNumbers}>
                  {['1', '2', '3', '4', '5+'].map(num => (
                    <label key={num} className={styles.checkLabel}>
                      <input
                        type="checkbox"
                        checked={banheirosActual == num}
                        onChange={() => onChangeBanheiros(num)}
                      />
                      <span>{num}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Vagas */}
              <div className={styles.formItem}>
                <label className={styles.formLabel}>Vagas</label>
                <div className={styles.checkNumbers}>
                  {['1', '2', '3', '4', '5+'].map(num => (
                    <label key={num} className={styles.checkLabel}>
                      <input
                        type="checkbox"
                        checked={vagasActual == num}
                        onChange={() => onChangeVagas(num)}
                      />
                      <span>{num}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className={styles.popupFooter}>
              <button 
                type="button"
                className={styles.clearBtn}
                onClick={clearFilters}
              >
                <span>Limpar filtros</span>
              </button>
              <Link 
                href={renderPath()}
                type="button"
                className={styles.searchBtn}
                style={{ backgroundColor: site?.cor2 || '#c4a853' }}
              >
                <span>Filtrar</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WelcomePieces2;
